import { signInWithGoogle, signInWithEmail, signUpWithEmail } from '../lib/auth.js';
import { navigate } from '../router.js';
import { brandMarkHtml } from '../components/brandMark.js';
import { humanizeAuthError } from '../lib/friendlyError.js';

export function renderLogin(container) {
  let mode = 'signin';

  function draw() {
    container.innerHTML = `
      <div class="center-screen">
        <div class="auth-card">
          <h1 style="display:flex;align-items:center;justify-content:center;gap:10px;">${brandMarkHtml()} Simustage</h1>
          <p style="text-align:center;color:var(--text-dim);margin-top:-8px;font-size:0.88rem;">
            Describe what you want to learn, and build it into a hands-on simulation.
          </p>
          <button class="btn" id="google-btn" style="width:100%;justify-content:center;margin-top:16px;">
            Continue with Google
          </button>
          <div class="divider">or</div>
          <form id="email-form">
            ${mode === 'signup' ? `<div class="field"><label>Name</label><input type="text" id="name" required /></div>` : ''}
            <div class="field"><label>Email</label><input type="email" id="email" required /></div>
            <div class="field"><label>Password</label><input type="password" id="password" required minlength="6" /></div>
            <div id="auth-error" style="color:var(--danger);font-size:0.82rem;margin-bottom:8px;"></div>
            <button class="btn btn-primary" type="submit" style="width:100%;justify-content:center;">
              ${mode === 'signup' ? 'Create account' : 'Sign in'}
            </button>
          </form>
          <p style="text-align:center;font-size:0.85rem;margin-top:14px;">
            ${mode === 'signup' ? 'Already have an account?' : "Don't have an account?"}
            <a href="#" id="toggle-mode" style="color:var(--accent);font-weight:600;">
              ${mode === 'signup' ? 'Sign in' : 'Sign up'}
            </a>
          </p>
          <p style="text-align:center;font-size:0.82rem;margin-top:6px;color:var(--text-dim);">
            Setting up a school or college?
            <a href="#/school/start" style="color:var(--accent);font-weight:600;">Start here →</a>
          </p>
        </div>
      </div>
    `;

    container.querySelector('#google-btn').addEventListener('click', async () => {
      try { await signInWithGoogle(); navigate('/'); } catch (e) { showError(e); }
    });

    container.querySelector('#toggle-mode').addEventListener('click', (e) => {
      e.preventDefault();
      mode = mode === 'signup' ? 'signin' : 'signup';
      draw();
    });

    container.querySelector('#email-form').addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = container.querySelector('#email').value.trim();
      const password = container.querySelector('#password').value;
      try {
        if (mode === 'signup') {
          const name = container.querySelector('#name').value.trim();
          await signUpWithEmail(email, password, name);
        } else {
          await signInWithEmail(email, password);
        }
        navigate('/');
      } catch (err) { showError(err); }
    });
  }

  function showError(err) {
    const el = container.querySelector('#auth-error');
    if (el) el.textContent = humanizeAuthError(err);
  }

  draw();
}

